import { createActions, createReducer } from 'reduxsauce'

import ConsultaCurriculosService from '../../servicos/ConsultaRemuneracaoADMRHService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaCurriculosInicio: [],
    buscaConsultaCurriculosErro: ['erro'],
    buscaConsultaCurriculosSucesso: ['consultaCurriculos'],
    limpar: [],
    setConsultaCurriculosEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaConsultaCurriculos = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaCurriculosInicio())
        let serv = new ConsultaCurriculosService()
        return serv
            .consultarCurriculos(filtro)
            .then(response => dispatch(Creators.buscaConsultaCurriculosSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaCurriculosErro(error)))
    }
}

const buscaConsultaCurriculosInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaCurriculosErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaConsultaCurriculosSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaCurriculos.resultado,
        dataSincronizacaoDados: action.consultaCurriculos.dataSincronizacaoDados,
        carregando: false,
        fonte: action.consultaCurriculos.fonte,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaCurriculosEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_CURRICULOS_INICIO]: buscaConsultaCurriculosInicio,
    [Types.BUSCA_CONSULTA_CURRICULOS_ERRO]: buscaConsultaCurriculosErro,
    [Types.BUSCA_CONSULTA_CURRICULOS_SUCESSO]: buscaConsultaCurriculosSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_CURRICULOS_ESTADO_DT]: setConsultaCurriculosEstadoDT,
})
